const availableLanguages = ['fr', 'en', 'nl', 'de', 'it', 'es'];
const defaultLanguage = 'fr';
let activeLanguage = defaultLanguage;

if (localStorage.language != null) {
    activeLanguage = localStorage.language;
} else if (navigator.language != null) {
    activeLanguage = navigator.language.split('-')[0];
}

if (availableLanguages.indexOf(activeLanguage) < 0) {
    activeLanguage = defaultLanguage;
}

localStorage.language = activeLanguage;

document.location = '/' + activeLanguage + document.location.pathname;

